const ContractMGType = {
  MG1: [1, 'Cấn trừ'],
  MG2: [2, 'Không cấn trừ'],
};

export default ContractMGType;
